<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24">
        <rect fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.90px" x="1.5" y="18.68" width="21" height="3.82"/>
        <rect fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.90px" x="2.45" y="1.5" width="19.09" height="17.18"/>
        <rect fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.90px" x="6.27" y="5.32" width="11.45" height="13.36"/>
        <line fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.90px" x1="6.27" y1="12" x2="17.73" y2="12"/>
        <line fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.90px" x1="12" y1="5.32" x2="12" y2="18.68"/>
    </svg>
</template>
